import "./App.css";
import "./assets/css/index.css";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Home from "./Pages/Home";
import Footer from "./layout/Footer";
import Header from "./layout/Header";

import ScrollToTop from "./hooks/ScrollToTop";

import { useContext, useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProductList from "./Pages/ProductList/ProductList";
import ProductDetails from "./Pages/ProductDetails/ProductDetails";
import Cart from "./Pages/Cart/Cart";
import ContactUs from "./Pages/ContactUs/ContactUs";
import AboutUs from "./Pages/AboutUs/AboutUs";
import TermsService from "./Pages/TermsService/TermsService";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import WishList from "./Pages/WishList/WishList";
import Checkout from "./Pages/Checkout/Checkout";
import Profile from "./Pages/Profile/Profile";
import OrderDetails from "./Pages/Profile/OrderDetails";
import useFcmToken from "./hooks/useFcmToken";

import { getMessaging, onMessage } from "firebase/messaging";
import firebaseApp from "./hooks/firebase";
import moment from "moment";
import Logout from "./Pages/Authentication/logout";
import { MyContext } from "./hooks/useContextProvider";
function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const { token } = useContext(MyContext);
  console.log('token465465: ', token);
  useEffect(() => {
    AOS.init({ once: false, duration: 1000 }); // Initialize AOS with custom options
  }, []);

  const [loading, setLoading] = useState(true);
  const [deviceInfo, setDeviceInfo] = useState({
    deviceId: "",
    ipAddress: "",
    latitude: "",
    longitude: "",
    clientId: process.env.REACT_APP_Client_Id,
  });
  const { fcmToken } = useFcmToken();
  // // Use the token as needed
  console.log("FCM token:", fcmToken);

  // // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (typeof window !== "undefined" && "serviceWorker" in navigator) {
      const messaging = getMessaging(firebaseApp);
      const unsubscribe = onMessage(messaging, (payload) => {
        console.log("Foreground push notification received:", payload);
        // Handle the received push notification while the app is in the foreground
        // You can display a notification or update the UI based on the payload
      });
      return () => {
        unsubscribe(); // Unsubscribe from the onMessage event
      };
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      console.log("FCM token:22222222222222", fcmToken);
      const fetchUserIP = async () => {
        console.log("++++++++++++++++++++++++++++++++++++++++++++++++++");
        try {
          let ipAddress = "";
          let latitude = "";
          let longitude = "";
          const response = await fetch("https://api.ipify.org?format=json");
          const data = await response.json();
          ipAddress = data.ip;
          localStorage.setItem("ipaddress", data.ip);

          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                latitude = position.coords.latitude;
                console.log(
                  "position.coords.latitude: ",
                  position.coords.latitude
                );
                longitude = position.coords.longitude;
              },
              (err) => {
                console.log(err.message);
              }
            );
          } else {
            console.log("Geolocation is not supported by this browser.");
          }

          await setTimeout(async () => {
            console.log(latitude, "_____________________");
            let formData = new FormData();
            const token = localStorage.getItem("token");
            const ipAddress = localStorage.getItem("ipaddress");

            formData.append("ipAddress", ipAddress);
            formData.append("clientId", process.env.REACT_APP_Client_Id);
            formData.append("visitDate", moment().format("YYYY-MM-DD"));
            if (latitude) {
              formData.append("latitude", latitude);
            }
            if (longitude) {
              formData.append("longitude", longitude);
            }
            formData.append("deviceId", "");
            formData.append("fcmToken", localStorage.getItem("fcmToken"));
            formData.append("visitTime", moment().format("h:mm:ss a"));
            formData.append("created_by", "anonymousUser");

            const apiCall = await fetch(
              `${process.env.REACT_APP_API_URL}addwebtraffic?clientId=${process.env.REACT_APP_Client_Id}&ipAddress=${ipAddress}`,
              {
                method: "POST",
                headers: {
                  Authorization: `Token ${token}`,

                  // "Content-Type": "application/json",
                },
                body: formData,
              }
            );

            console.log("apiCall: ", apiCall);
          }, 1000);
        } catch (error) {
          console.error("Error fetching IP address:", error);
        }
      };

      fetchUserIP();

      const handleOnline = () => {
        fetchUserIP();
      };

      window.addEventListener("online", handleOnline);
      return () => {
        window.removeEventListener("online", handleOnline);
      };
    }, 3000);
  }, []);

  useEffect(() => {
    if (!token) {
      if (
        location?.pathname === "/cart" ||
        location?.pathname === "/wishlist" ||
        location?.pathname === "/checkout" ||
        location?.pathname === "/profile" ||
        location?.pathname?.split("/")[1] === "order-details"
      ) {
        navigate("/");
      }
    }
  }, [navigate, location?.pathname, token]);
  console.log("location?.pathname: ", location?.pathname?.split("/")[1]);
  return (
    <main
      id="top"
      style={{
        height:
          location?.pathname?.split("/")?.[1] === "product-details" && "100vh",
        overflowY:
          location?.pathname?.split("/")?.[1] === "product-details" && "auto",
      }}
    >
      <div
        class={
          location?.pathname === "/"
            ? "home page-template page-template-elementor_header_footer page page-id-191 wp-embed-responsive theme-furniforma layout-boxed has-go-to-top furniforma-plus-1.0.0 furniforma-pro-1.0.0 woocommerce-no-js woo-variation-swatches wvs-behavior-hide wvs-theme-furniforma wvs-show-label tinvwl-theme-style elementor-default elementor-template-full-width elementor-kit-9 elementor-page elementor-page-191 currency-usd"
            : "product-template product-template-elementor_header_footer single single-product postid-1621 wp-embed-responsive theme-furniforma layout-boxed has-go-to-top furniforma-plus-1.0.0 furniforma-pro-1.0.0 woocommerce woocommerce-page woocommerce-no-js woo-variation-swatches wvs-behavior-hide wvs-theme-furniforma wvs-show-label tinvwl-theme-style elementor-default elementor-kit-9 elementor-page elementor-page-1621 currency-usd"
        }
      >
        <div class="wrapper">
          <div class="inner-wrapper">
            <ToastContainer
              theme="light"
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              className={"custom-toast"}
            />

            <ScrollToTop />
            <Header />
            <Routes>
              <Route path="/" exact element={<Home />} />

              <Route path="/:referralCode" exact element={<Home />} />
              <Route exact path="/shop" element={<ProductList />} />
              <Route
                exact
                path="/product-details/:id"
                element={<ProductDetails />}
              />
              {token && <Route exact path="/cart" element={<Cart />} />}
              <Route exact path="/contact-us" element={<ContactUs />} />
              <Route exact path="/about-us" element={<AboutUs />} />
              <Route
                exact
                path="/terms-and-condition"
                element={<TermsService />}
              />
              <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
              {token && <Route exact path="/wishlist" element={<WishList />} />}
              {token && <Route exact path="/checkout" element={<Checkout />} />}
              {token && <Route exact path="/profile" element={<Profile />} />}
              <Route exact path="/logout" element={<Logout />} />
              {token && (
                <Route
                  exact
                  path="/order-details/:id"
                  element={<OrderDetails />}
                />
              )}
            </Routes>

            <Footer />

            {/* <button
        className="toTopButton js-top-button  "
        onClick={() => {
          window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
          document.getElementById("top").scrollTo(0, 0);
        }}
      >
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_83_4004)">
            <path d="M17.8783 0H4.12177C3.59388 0 3.16602 0.42786 3.16602 0.955755C3.16602 1.48365 3.59388 1.91151 4.12177 1.91151H17.8783C18.4062 1.91151 18.834 1.48365 18.834 0.955755C18.834 0.42786 18.4062 0 17.8783 0Z"></path>
            <path d="M11.6759 4.67546C11.3026 4.30219 10.6975 4.30219 10.3242 4.67546L6.04107 8.95863C5.66779 9.3319 5.66779 9.937 6.04107 10.3103C6.41434 10.6837 7.01955 10.6836 7.39272 10.3103L10.0444 7.6587V21.0443C10.0444 21.5722 10.4723 22 11.0002 22C11.5281 22 11.9559 21.5722 11.9559 21.0443V7.65859L14.6076 10.3102C14.7942 10.4969 15.0389 10.5901 15.2834 10.5901C15.528 10.5901 15.7726 10.4968 15.9593 10.3102C16.3325 9.9369 16.3325 9.3318 15.9593 8.95852L11.6759 4.67546Z"></path>
          </g>
          <defs>
            <clipPath id="clip0_83_4004">
              <rect width="22" height="22" fill="white"></rect>
            </clipPath>
          </defs>
        </svg>
      </button> */}
          </div>
        </div>
      </div>
    </main>
  );
}

export default App;
